// <fw-carousel>: native scroll-snap track + prev/next + progress thumb. No dependencies.
if (!customElements.get('fw-carousel')) {
  customElements.define('fw-carousel', class FwCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.fw-carousel__track');
      this.thumb = this.querySelector('.fw-carousel__thumb');
      this.prev = this.querySelector('[data-fw-prev]');
      this.next = this.querySelector('[data-fw-next]');
      if (!this.track) return;
      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.ro = new ResizeObserver(this.update);
      this.ro.observe(this.track);
      this.prev && this.prev.addEventListener('click', () => this.step(-1));
      this.next && this.next.addEventListener('click', () => this.step(1));
      this.update();
    }
    disconnectedCallback() { this.ro && this.ro.disconnect(); }
    step(dir) {
      const slide = this.track.querySelector('.fw-carousel__slide');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const w = slide ? slide.getBoundingClientRect().width + gap : this.track.clientWidth;
      this.track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    update() {
      const t = this.track, max = t.scrollWidth - t.clientWidth;
      if (this.thumb) {
        this.thumb.style.width = (t.clientWidth / t.scrollWidth * 100) + '%';
        this.thumb.style.left = (t.scrollLeft / t.scrollWidth * 100) + '%';
      }
      if (this.prev) this.prev.disabled = t.scrollLeft <= 1;
      if (this.next) this.next.disabled = t.scrollLeft >= max - 1;
      this.toggleAttribute('data-static', max <= 1);
    }
  });
}
